export default __webpack_public_path__ + "static/media/button.b0de199c.svg";